import React from 'react';
import memoizeOne from 'memoize-one';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import VersionPicker from '@atlassian/jira-version-picker/src/view/single/index.tsx';
import type { ReleaseVersionValidationErrors, ReleasableVersion } from '../../../model/index.tsx';
import { releaseVersionUpdate, swapIssues } from '../../../state/actions.tsx';
import {
	getErrors,
	isSaving as isSavingSelector,
	getTodoInProgressIssuesCount,
	isSwapSelected,
	getPropsForVersionPicker,
} from '../../../state/selectors.tsx';
import type { State } from '../../../state/types.tsx';
import SwapIssues, { type RenderVersionPicker } from './view.tsx';

export type StateProps = {
	readonly toDoInProgressIssuesCount: number;
	readonly isSaving: boolean;
	readonly shouldSwapIssues: boolean;
	readonly errors: ReleaseVersionValidationErrors;
	readonly renderVersionPicker: RenderVersionPicker;
};

export type DispatchProps = {
	readonly onInputChange: (arg1: Partial<ReleasableVersion>) => void;
	readonly onSwapIssuesSelected: (arg1: boolean) => void;
};

type VersionPickerProps = ReturnType<typeof getPropsForVersionPicker>;

const mapStateToProps = () => {
	const renderVersionPickerFactory = memoizeOne(
		(
			shouldSwapIssues: VersionPickerProps['shouldSwapIssues'],
			isSaving: VersionPickerProps['isSaving'],
			baseUrl: VersionPickerProps['baseUrl'],
			projectKey: VersionPickerProps['projectKey'],
			versionId: VersionPickerProps['versionId'],
		): RenderVersionPicker =>
			(props) => (
				<VersionPicker
					isDisabled={!shouldSwapIssues || isSaving}
					baseUrl={baseUrl}
					projectKey={projectKey}
					ignore={[versionId]}
					versionStatuses={['UNRELEASED']}
					{...props}
				/>
			),
	);

	return (state: State): StateProps => {
		const { baseUrl, projectKey, shouldSwapIssues, isSaving, versionId } =
			getPropsForVersionPicker(state);

		return {
			toDoInProgressIssuesCount: getTodoInProgressIssuesCount(state),
			isSaving: isSavingSelector(state),
			shouldSwapIssues: isSwapSelected(state),
			errors: getErrors(state),
			renderVersionPicker: renderVersionPickerFactory(
				shouldSwapIssues,
				isSaving,
				baseUrl,
				projectKey,
				versionId,
			),
		};
	};
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dispatcher = (dispatch: any) => ({
	// @ts-expect-error - TS7006 - Parameter 'version' implicitly has an 'any' type.
	onInputChange: (version) => dispatch(releaseVersionUpdate(version)),
	// @ts-expect-error - TS7006 - Parameter 'swap' implicitly has an 'any' type.
	onSwapIssuesSelected: (swap) => dispatch(swapIssues(swap)),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = (dispatch: any): DispatchProps => dispatcher(dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SwapIssues);
